import { render, staticRenderFns } from "./policy-holder-info.vue?vue&type=template&id=01a8bbb2&scoped=true&"
import script from "./policy-holder-info.vue?vue&type=script&lang=js&"
export * from "./policy-holder-info.vue?vue&type=script&lang=js&"
import style0 from "./policy-holder-info.vue?vue&type=style&index=0&id=01a8bbb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8bbb2",
  null
  
)

export default component.exports